import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { getEnvConfig } from '@utils/shared.environment.utils';

function createAppInsights(): {
  appInsights: ApplicationInsights;
  reactPlugin: ReactPlugin;
} | null {
  const connectionString = getEnvConfig().VITE_APPLICATIONINSIGHTS_CONNECTION_STRING;

  if (!connectionString) {
    console.warn('Application Insights connection string not configured');
    return null;
  }

  const reactPlugin = new ReactPlugin();
  const instance = new ApplicationInsights({
    config: {
      connectionString,
      // Route tracking is handled manually via router.subscribe in ApplicationInsightsProvider
      // Do NOT re-enable — it would cause duplicate page view events
      enableAutoRouteTracking: false,
      enableCorsCorrelation: true,
      extensions: [reactPlugin],
    },
  });

  instance.loadAppInsights();
  instance.trackPageView();

  return {appInsights: instance, reactPlugin};
}

const ai = createAppInsights();
export const appInsights = ai?.appInsights ?? null;
export const reactPlugin = ai?.reactPlugin ?? null;

export function trackException(error: unknown): void {
  appInsights?.trackException({
    exception:
      error instanceof Error
        ? error
        : new Error(typeof error === 'object' ? JSON.stringify(error) : String(error)),
  });
}
